(() => {
  const body = document.body;
  const page = body.dataset.obhMotionPage;
  if (!page) return;

  const plans = {
    home: [
      ['.hero__media img', 'hero'],
      ['.story__content', 'right'],
      ['.about__top', 'up'],
      ['.about__body, .about__welcome', 'up'],
      ['.wards__head', 'up'],
      ['.wards__carousel, .wards__btn', 'fade'],
      ['.strip', 'fade'],
      ['.collx__head, .collx__actions', 'up'],
      ['.collx__track', 'fade'],
      ['.contact__form-col', 'left'],
      ['.contact__info-col', 'right']
    ],
    about: [
      ['.hero__media img', 'hero'],
      ['.intro__heading, .intro__body, .intro__actions', 'up'],
      ['.fsplit__heading, .fsplit__body, .fsplit__signature', 'left'],
      ['.fsplit__media', 'right'],
      ['.contact__form-col', 'left'],
      ['.contact__info-col', 'right']
    ],
    wards: [
      ['.hero__media img', 'hero'],
      ['.intro__heading, .intro__body', 'up'],
      ['.ward__head', 'up'],
      ['.ward__carousel, .ward__actions, .ward__empty', 'fade'],
      ['.contact__form-col', 'left'],
      ['.contact__info-col', 'right']
    ],
    legal: [
      ['.legal__heading, .legal__subheading, .legal__intro', 'up'],
      ['.legal__item', 'up'],
      ['.legal__closing', 'up'],
      ['.faq__head, .faq__item', 'up'],
      ['.contact__form-col', 'left'],
      ['.contact__info-col', 'right']
    ],
    contact: [
      ['.intro__heading, .intro__body', 'up'],
      ['.contact__form-col', 'left'],
      ['.contact__info-col', 'right']
    ],
    policy: [
      ['.shopify-policy__title', 'up'],
      ['.shopify-policy__body .rte > *', 'up']
    ]
  };

  const elements = [];
  (plans[page] || []).forEach(([selector, variant]) => {
    document.querySelectorAll(selector).forEach((element, index) => {
      if (element.dataset.obhReveal) return;
      element.dataset.obhReveal = variant;
      element.style.setProperty('--obh-reveal-delay', `${Math.min(index % 4, 3) * 65}ms`);
      elements.push(element);
    });
  });

  if (!elements.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add('is-visible'));
    body.classList.add('obh-motion-ready');
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  elements.forEach((element) => {
    const rect = element.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.94 && rect.bottom > 0) {
      element.classList.add('is-visible');
    } else {
      observer.observe(element);
    }
  });

  requestAnimationFrame(() => body.classList.add('obh-motion-ready'));
})();
